import React from "react";
import styles from "./styles.module.scss";
// Components
import InstallationNextButton from "../InstallationNextButton";
import InstallationGoBackButton from "../InstallationGoBackButton";

type InstallationSplashProps = {
  isDesktop?: boolean;
  icon?: React.ReactNode;
  headers: string[];
  message?: string[];
  email?: string;
  goBackOnClick?: () => void;
  goBackButtonLabel?: string;
  nextButtonOnClick?: () => void;
  nextButtonLabel?: string;
  cypresstestid?: string;
  troubleshooting?: string[];
  doNotFlexContainer?: boolean;
  innerContentHalfSize?: boolean;
};

const InstallationSplash = ({
  isDesktop,
  icon,
  headers,
  message,
  email,
  goBackOnClick,
  goBackButtonLabel,
  nextButtonOnClick,
  nextButtonLabel,
  cypresstestid,
  troubleshooting,
  doNotFlexContainer,
  innerContentHalfSize,
}: InstallationSplashProps) => {
  return (
    <div
      className={
        doNotFlexContainer
          ? styles.do_not_flex_container
          : styles.splash_container
      }
      data-testid={cypresstestid}
    >
      <div
        className={
          innerContentHalfSize ? styles.half_vh_splash_top : styles.splash_top
        }
      >
        <div className={styles.icon}>{icon}</div>
        {headers.map((header, i) => (
          <div className={styles.installation_header} key={i} data-private>
            {header}
          </div>
        ))}
        {troubleshooting && troubleshooting.length > 0 &&
          troubleshooting.map((step, i) => (
            <div key={i} className={styles.installation_message}>{step}</div>
          ))}
        {message && (
          <div className={styles.installation_message}>
            {message.map((msg, index) => (
              <div key={index} className={styles.message_item}>
                {msg}
              </div>
            ))}
            {email && (
              <span>
                <a
                  href={`mailto: ${email}`}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.email}
                >
                  {email}
                </a>
              </span>
            )}
          </div>
        )}
      </div>
      <div className={styles.splash_bottom}>
        {goBackButtonLabel && goBackOnClick && (
          <InstallationGoBackButton
            onClick={goBackOnClick}
            isDesktop={isDesktop}
            label={goBackButtonLabel}
          />
        )}
        {nextButtonLabel && nextButtonOnClick && (
          <InstallationNextButton
            onClick={nextButtonOnClick}
            label={nextButtonLabel}
          />
        )}
      </div>
    </div>
  );
};

export default InstallationSplash;
